import { Box, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { toast } from 'material-react-toastify';
import Grid from '@mui/material/Grid2';
import { bodyWidth } from '../../utils/Style';
import { Brand } from '../../interfaces/Brand/Brand';
import { getBrands } from '../../api/Brand';
import { BrandCard } from './BrandCard';
import { BrandPlaceholder } from './BrandPlaceholder';
import { GenericHelmet } from '../../components/Helmet/GenericHelmet';
import { useLocalizedText } from '../../hooks/useLocalizedText';

export const BrandsPage = () => {
  const t = useLocalizedText();

  const [brands, setBrands] = useState<Brand[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    getBrands()
      .then((b) => setBrands(b))
      .catch((err) => toast.error(err.message))
      .finally(() => setLoading(false));
  }, []);

  const itemSize = {
    xs: 6,
    sm: 4,
    md: 3,
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        alignItems: 'center',
      }}
    >
      <GenericHelmet
        title={t('brand.brands')}
        meta={{ canonicalURL: 'markalar' }}
      />

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          width: bodyWidth,
          py: 3,
          px: 1.5,
          gap: 1.5,
          boxSizing: 'border-box',
        }}
      >
        <Typography sx={{ fontSize: '22px', fontWeight: 700 }}>
          {t('brand.brands')}
        </Typography>

        <Grid container spacing={{ xs: 3 }} width='100%'>
          {loading
            ? Array(12)
                .fill(null)
                .map((_, i) => (
                  <Grid key={i} size={itemSize}>
                    <BrandPlaceholder />
                  </Grid>
                ))
            : brands.map((brand) => (
                <Grid key={brand.id} size={itemSize}>
                  <BrandCard brand={brand} />
                </Grid>
              ))}
        </Grid>
      </Box>
    </Box>
  );
};
